// extracted by mini-css-extract-plugin
module.exports = {"page-body":"PageHeader_page-body__3LCcZ","header":"PageHeader_header__1rb9D"};